import React, { useEffect, useRef, useState } from "react";
import styles from './MainLayout.module.scss';
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import PropTypes from "prop-types";
import Header from "../../components/header/Header";
import useDeviceType from "../../hooks/useDeviceType";
import Toast from "../../components/toast/Toast";
import useClickOutside from "../../hooks/useClickOutside";
import Menu from "../../components/menu/Menu";
import { usePushNotifications } from "../../hooks/usePushNotifications";
import { useToasts } from "../../contexts/ToastContext";
import NotificationBanner from "../../components/notificationBanner/NotificationBanner";

const MainLayout = ({
  children = null
}) => {
  const { showToast } = useToasts();
  const { enable, permission } = usePushNotifications(showToast);
  const [showMenu, setShowMenu] = useState(false);
  const { isDesktopAndAbove } = useDeviceType();
  const sidBarRef = useRef(null);
  const containerRef = useRef(null);
  const location = useLocation()

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [location]);

  useClickOutside(sidBarRef, () => setShowMenu(false));
  
  return (
    <div className={styles.layout}>
      <div className={styles.header}>
        <Header
          showMenu={showMenu}
          onToggleMenu={(toggle) => setShowMenu(toggle)}
        />
      </div>
      <main className={styles.main}>
        <Toast />
        { (isDesktopAndAbove || showMenu) && <aside className={styles.sidebar} ref={sidBarRef}>
          <Menu
            onClick={() => setShowMenu(false)}
          />
        </aside>}
        <div className={styles.container} ref={containerRef}>
          {permission === "default" && (
            <NotificationBanner onEnable={enable} />
          )}
          { children || <Outlet /> }
        </div>
      </main>
      <footer className={styles.footer}>
        <Footer />
      </footer>
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node
};

export default MainLayout;